//libs
import { styled } from '@nykaa/ui-components';

//components
import BaseTipTile from 'shared/layouts/Listing/Desktop/components/Layout/components/TipTile';
import BaseProduct from 'shared/components/ProductV2';
import BasePlaceholder from 'shared/layouts/Listing/components/ProductPlaceholder';
import RenderIfVisible from 'shared/components/RenderIfVisible';
import PromotionText from 'shared/components/PromotionText';

// styles
import { truncate } from 'shared/styles/mixin';

export const Container = styled.div`
  width: 100%;
`;

export const ProductRow = styled(RenderIfVisible)`
  display: flex;
  max-width: 100%;
  flex-flow: row wrap;
`;

const BaseElement = styled.div`
  width: ${({ theme }) => `calc(25% - ${theme.spacing.spacing120})`};
  margin-left: ${({ theme }) => theme.spacing.spacing120};
  margin-bottom: ${({ theme }) => theme.spacing.spacing100};
`;
export const TipTile = BaseElement.withComponent(BaseTipTile);

export const Product = BaseElement.withComponent(BaseProduct);

export const ProductPlaceholder = BaseElement.withComponent(BasePlaceholder);

export const ImageChild = styled.div`
  position: relative;
  margin-top: ${({ theme }) => theme.spacing.spacing40};
`;

export const UrgencyNudgeContainer = styled(PromotionText)`
  padding: 0;
  ${({ theme }) => theme.typography.bodySmall};
`;

export const PromotionTextContainer = styled(PromotionText)`
  ${({ theme }) => theme.typography.bodySmall};
`;

export const ProductStamp = styled.div<{ backgroundColor: string }>`
  width: 100%;
  ${truncate};
  ${({ theme }) => theme.typography.bodyXSmall};
  ${({ theme, backgroundColor }) => `
  background-color: ${backgroundColor ? backgroundColor : theme.colors.surface30};
  color: ${theme.colors.primary};
  padding: ${theme.spacing.spacing10} ${theme.spacing.spacing40};
  `}
`;
